import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./app.scss";
import { HomePage } from "./pages/home";
import { LoginPage } from "./pages/login";
import { AuthProvider } from './services/auth.service';
import { GraphsPage } from "./pages/graphs";

/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
export default function App()
{
    return (
        <BrowserRouter basename="/">
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/graph" element={<GraphsPage race={"20250302AUT6"}  />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
